/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Grid, Tooltip, Typography } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import AutoCompleteDropdown from "../../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";
import { RELATION_OPTIONS } from "../../../../../contants";
import { FAMILY_FIELDS } from "../../../../../contants/formFields";
import Member from "../../../../../services/api/member";
import { debounce, isEmptyObj } from "../../../../../utils/helper";
import Styles from "../MemberRow/MemberRow.styles";

function FamilyRelation({
  deleteFamilyMember,
  index,
  familyMember,
  options,
  updateFamilyMember,
  readOnly,
}) {
  // OLD CODE: Related Member was a static Dropdown using only family members,
  // which resulted in an empty dropdown when only one member was added.
  // const relatedMemerOptions = useMemo(() => {
  //   if (!isEmptyObj(familyMember) && options) {
  //     return options.filter((opt) => opt.value !== familyMember.memberId);
  //   }
  //   return [];
  // }, [familyMember, options]);

  const [relatedMemberSearchData, setRelatedMemberSearchData] = useState([]);
  const [relatedMemberLoading, setRelatedMemberLoading] = useState(false);

  // Convert family member options to AutoComplete format (for edit mode backward compatibility)
  const initialRelatedMemberOptions = useMemo(() => {
    if (!isEmptyObj(familyMember) && options) {
      return options
        .filter((opt) => opt.value !== familyMember.memberId)
        .map((opt) => ({ displayName: opt.key, value: opt.value }));
    }
    return [];
  }, [familyMember, options]);

  // Merged options: family member options + API search results (deduped)
  const mergedRelatedMemberOptions = useMemo(() => {
    const allOptions = [...initialRelatedMemberOptions];
    relatedMemberSearchData.forEach((searchOpt) => {
      if (!allOptions.find((opt) => opt.value === searchOpt.value)) {
        allOptions.push(searchOpt);
      }
    });
    return allOptions;
  }, [initialRelatedMemberOptions, relatedMemberSearchData]);

  const onSearchRelatedMember = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) return;
    try {
      setRelatedMemberLoading(true);
      const isNumericSearch = !Number.isNaN(Number(searchTerm));
      const formattedQuery = isNumericSearch
        ? { memberId: Number(searchTerm) }
        : { fullName: searchTerm };
      const { data } = await Member.search(
        formattedQuery,
        { pageSize: 5 },
        false
      );
      const searchResults = data.content.map((m) => ({
        displayName: `${m.fullName} (${m.memberId})`,
        value: m.memberId,
      }));
      setRelatedMemberSearchData(searchResults);
    } catch (error) {
      // silently handle search errors
    } finally {
      setRelatedMemberLoading(false);
    }
  };

  const handleRelatedMemberInputChange = useCallback(
    debounce(onSearchRelatedMember),
    [familyMember]
  );
  return (
    <Grid container spacing={0}>
      <Grid item xs={5.8} md={2.8} sx={{ padding: "10px" }}>
        <Dropdown
          name={FAMILY_FIELDS.MEMBER_ID}
          value={familyMember.memberId}
          options={options}
          label="Member"
          onChange={(e) =>
            updateFamilyMember({ memberId: e.target.value }, familyMember.id)
          }
          disabled={readOnly}
        />
      </Grid>
      <Typography
        // fontSize="12px"
        style={{
          textAlign: "end",
          marginTop: "20px",
        }}
      >
        is
      </Typography>
      <Grid item xs={5.8} md={2.8} sx={{ padding: "10px" }}>
        <Dropdown
          value={familyMember.relationType}
          name={FAMILY_FIELDS.RELATED_MEMBER_ID}
          options={RELATION_OPTIONS}
          label="Relation"
          onChange={(e) =>
            updateFamilyMember(
              { relationType: e.target.value },
              familyMember.id
            )
          }
          disabled={readOnly}
        />
      </Grid>
      <Typography
        style={{
          textAlign: "end",
          marginTop: "20px",
        }}
      >
        of
      </Typography>
      <Grid item xs={5.8} md={2.8} sx={{ padding: "10px" }}>
        {/* OLD CODE: Static Dropdown for Related Member — was empty when only one family member added */}
        {/* <Dropdown
          value={familyMember.relatedMemberId}
          name={FAMILY_FIELDS.RELATED_MEMBER_ID}
          options={relatedMemerOptions}
          label="Related Member"
          onChange={(e) =>
            updateFamilyMember(
              { relatedMemberId: e.target.value },
              familyMember.id
            )
          }
          disabled={readOnly}
        /> */}
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.displayName || ""}
          label="Related Member"
          name={FAMILY_FIELDS.RELATED_MEMBER_ID}
          options={mergedRelatedMemberOptions}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              updateFamilyMember({ relatedMemberId: "" }, familyMember.id);
              setRelatedMemberSearchData([]);
            } else {
              updateFamilyMember(
                { relatedMemberId: selectedValue.value },
                familyMember.id
              );
            }
          }}
          onInputChange={handleRelatedMemberInputChange}
          value={familyMember.relatedMemberId}
          loading={relatedMemberLoading}
          filterSelectedOptions={false}
          filterOptions={(x) => x}
          disabled={readOnly}
        />
      </Grid>

      <Grid
        item
        xs={6}
        md={2.7}
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          paddingLeft: "30px",
        }}
      >
        <div style={{ ...Styles.item, ...Styles.colName }}>
          {index === 0 && (
            <Typography
              fontSize="12px"
              style={{
                position: "absolute",
                top: -16,
              }}
            >
              Actions
            </Typography>
          )}
          <Tooltip title="Delete">
            <DeleteOutlineIcon
              style={
                readOnly
                  ? { cursor: "not-allowed", opacity: "0.5" }
                  : { cursor: "pointer" }
              }
              onClick={() =>
                !readOnly ? deleteFamilyMember(familyMember.id) : {}
              }
            />
          </Tooltip>
        </div>
      </Grid>
    </Grid>
  );
}

export default FamilyRelation;
